import { useState } from "react";
import { IMinerSectionProps } from "./MinerSection.props";

interface IMinerSectionControl {
  readonly outOfRange: boolean;
}

export const useMinerSectionControl = (
  props: IMinerSectionProps
): IMinerSectionControl => {
  const [outOfRange, setOutOfRange] = useState<boolean>(false);

  return { outOfRange };
};
